export const CloseCamera = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
    <path opacity="0.8" d="M1 1L17 17" stroke="white" stroke-width="2" stroke-miterlimit="10" />
    <path opacity="0.8" d="M17.5 1.5L1.5 17.5" stroke="white" stroke-width="2" stroke-miterlimit="10" />
  </svg>
);
